'use client'

import { Link, usePathname } from '@/shared/i18n'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from '@/shared/ui/breadcrumb'
import { LucideHome } from 'lucide-react'
import { Fragment } from 'react'

export const Breadcrumbs = ({ mapLevel }: { mapLevel: (string | null)[] }) => {
  const pathname = usePathname()
  const segments = pathname.split('/').filter(Boolean)
  const breadcrumbs = segments.map((segment, index) => {
    const href = '/' + segments.slice(0, index + 1).join('/')
    const label = decodeURIComponent(segment).replace(/-/g, ' ')

    return {
      label,
      href,
    }
  })
  return (
    <Breadcrumb className={'self-center'}>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link href={'/'}>
              <LucideHome className={'h-5 w-5'} />
              <span className="sr-only">Home breadcrumbs</span>
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        {breadcrumbs.map((breadcrumb, index) => (
          <Fragment key={index}>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              {index !== breadcrumbs.length - 1 ? (
                <BreadcrumbLink asChild>
                  <Link href={breadcrumb.href}>
                    <span className={'text-xs md:text-sm lg:text-base select-none'}>
                      {mapLevel[index] || breadcrumb.label}
                    </span>
                  </Link>
                </BreadcrumbLink>
              ) : (
                <span className={'text-xs md:text-sm lg:text-base select-none'}>
                  {mapLevel[index] || breadcrumb.label}
                </span>
              )}
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
